import type z from 'zod/v4'
import { relations, sql } from 'drizzle-orm'
import { index, integer, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { user } from '../../auth'

// =============================================================================
// TOP ACHIEVERS - Lookup table (generated by cron job / background function)
// Stores users with the most badges for quick display
// =============================================================================

export const TopAchievers = pgTable(
  'top_achievers',
  {
    id: uuid().defaultRandom().primaryKey(),
    userId: text()
      .references(() => user.id, { onDelete: 'cascade' })
      .notNull()
      .unique(),
    badgeCount: integer().notNull().default(0),
    createdAt: timestamp({ mode: 'date', withTimezone: true }).defaultNow().notNull(),
    updatedAt: timestamp({ mode: 'date', withTimezone: true }).$onUpdateFn(() => sql`now()`),
  },
  (t) => [index('idx_top_achievers_user').on(t.userId), index('idx_top_achievers_badge_count').on(t.badgeCount)],
)

export const topAchieversRelations = relations(TopAchievers, ({ one }) => ({
  user: one(user, {
    fields: [TopAchievers.userId],
    references: [user.id],
  }),
}))

export const InsertTopAchieversSchema = createInsertSchema(TopAchievers).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
})

export const UpdateTopAchieversSchema = createUpdateSchema(TopAchievers).partial().omit({
  id: true,
  userId: true,
  createdAt: true,
  updatedAt: true,
})

export const SelectTopAchieversSchema = createSelectSchema(TopAchievers)

export type InsertTopAchievers = typeof TopAchievers.$inferInsert
export type UpdateTopAchievers = z.infer<typeof UpdateTopAchieversSchema>
export type SelectTopAchievers = typeof TopAchievers.$inferSelect
